import { toastError } from 'components/ToastComponent/ToastComponent'
import { gaEvent } from 'utils/ga'
import Qs from 'query-string'
import libFilters from 'lib/filters'
import { getUtms } from 'utils/Utms'
import * as providers from './provider'
import { filtersDictionary } from './dictionaries'

const translateFilters = frontEndFields => {
  const newFilters = {}
  Object.keys(frontEndFields).forEach(frontEndField => {
    const filterTranslation = filtersDictionary[frontEndField]
    let filterValue = frontEndFields[frontEndField]

    if (filterValue instanceof Array) {
      filterValue = filterValue.map(value => {
        return filtersDictionary[value] || value
      })
    } else {
      filterValue = filtersDictionary[filterValue] || filterValue
    }

    if (filterTranslation) {
      newFilters[filterTranslation] = filterValue
    } else {
      newFilters[frontEndField] = filterValue
    }
  })

  return newFilters
}

export default setAlert => {
  const setField = (field, value) => {
    setAlert(prev => ({ ...prev, form: { ...prev.form, [field]: value } }))
  }

  const clearStateAlert = () => {
    setAlert(prev => ({
      ...prev,
      form: {
        periodicity: {
          daily: false,
          weekly: false,
          avaiable: false,
        },
        whatsapp: false,
        purpose: {
          live: false,
          invest: false,
        },
      },
    }))
  }

  const fetchAlert = async (alert, filters, checkOffers, checkOffersResale) => {
    const utms = getUtms()
    const alertsProperties = { ...alert, ...utms }

    const filter = {
      localidade: filters.selectedLocalities.map(city => city.slug) || null,
      valor_max: Math.round(filters.valueRange.max),
      valor_min: Math.round(filters.valueRange.min),
      periodicidade: alert.periodicity,
      'buscar-regiao': filters.surroundingsSearch,
    }

    const dynamicFilters = {
      'Tipo de Imóvel': filters.filters['Tipo de Imóvel'],
      finalidade: filters.filters.Finalidade,
    }

    Object.keys(dynamicFilters).forEach(filterName => {
      if (!Array.isArray(dynamicFilters[filterName])) {
        return
      }
      const checkedFields = []

      dynamicFilters[filterName].forEach(currentFilter => {
        if (currentFilter.checked) {
          checkedFields.push(currentFilter.value)
        }
      })

      filter[filterName] = checkedFields
    })

    alertsProperties.filters = filter
    delete alertsProperties.purpose
    delete alertsProperties.periodicity

    const selectedFilter = Object.keys(alertsProperties.filters).some(item => {
      const currentItem = alertsProperties.filters[item]

      if (
        (Array.isArray(currentItem) && currentItem.length) ||
        (item === 'valor_max' &&
          currentItem !== libFilters.initialValueRange.max) ||
        (item === 'valor_min' &&
          currentItem !== libFilters.initialValueRange.min) ||
        (item === 'localidade' && currentItem.length)
      ) {
        return true
      }
      return false
    })

    if (!selectedFilter) {
      toastError('Você precisa selecionar pelo menos um filtro.')
      return false
    }

    alertsProperties.filters = translateFilters(alertsProperties.filters)

    const [err, res] = await providers.createAlert(
      alertsProperties,
      checkOffers,
      checkOffersResale
    )

    if (err) {
      toastError('Não foi possível criar o seu alerta!')
      return false
    }
    const ReactGALabel = purpose => {
      const { live, invest } = purpose
      if (live && invest) {
        return 'comprar_investir/morar'
      }

      if (live) {
        return 'comprar_morar'
      }

      return 'comprar_investir'
    }
    gaEvent({
      category: 'L_Rosie_Alerta',
      action: 'submit',
      label: ReactGALabel(alert.purpose),
    })
    return res
  }

  const setOpenAlertModal = async () => {
    setAlert(prev => ({
      ...prev,
      openModal: !prev.openModal,
      type: 'alertModal',
    }))
  }

  const setOpenExitModal = async () => {
    setAlert(prev => ({ ...prev, openExitModal: !prev.openExitModal }))
  }

  const checkOpenModalParams = urlParams => {
    const { openAlertModal = false } =
      Qs.parse(urlParams, { arrayFormat: 'comma' }) || {}
    if (openAlertModal === 'true') {
      setAlert(prev => ({ ...prev, openModal: true }))
    }
  }

  return {
    setField,
    fetchAlert,
    clearStateAlert,
    setOpenAlertModal,
    setOpenExitModal,
    checkOpenModalParams,
  }
}
